import styled from 'styled-components';
import { getSpace, gridContainer, maxContentWidth, mq, setGridColumns } from '@stylesheets/tools';

const StyledStackView = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  contain: paint;
  height: var(--height);
  --height: 100vh;

  .stack-view__inner {
    position: sticky;
    top: 0;
    height: 100vh;
    display: flex;
    width: 100%;
    flex-direction: column;
  }

  .stack-view__content {
    flex-grow: 2;
    display: flex;
    align-items: center;
    ${maxContentWidth('1440px')}
    padding: 0 ${getSpace('m')};
    width: 100%;
    height: calc(100vh - 144px);
    
    ${mq('l')} {
      ${gridContainer()}
      ${setGridColumns('1fr', 12)}
      padding: 0 ${getSpace('l')};
      padding-top: ${getSpace('xxl')};
      grid-template-rows: 1fr;
    }
  }

  .stack-view__timeline {
    flex-shrink: 0;
  }

  .stack-view__card-stack {
    grid-column: 1 / -1;
    margin-left: ${getSpace('xxs')};

    ${mq('m')} {
      align-self: center;
      grid-column: 5 / -1;
      margin-left: ${getSpace('m')};
    }

    ${mq('l')} {
      grid-column: 5 / -2;
    }

    ${mq('xl')} {
      padding-right: 0;
      grid-column: 5 / -3;
    }

    ${mq('xxl')} {
      margin-left: 0;
      grid-column: 5 / -4;
    }
  }

  .stack-view__scroll-indicator {
    ${mq('xl')} {
      grid-column: 11 / -1;
      transform: translateY(-40px);
    }

    ${mq('xxl')} {
      grid-column: 10 / -1;
      transform: translateY(-40px) translateX(60px);
    }
  }

  .stack-view__filter {
    display: none;
    position: relative;
    padding-right: 20px;
    padding-top: 10px;
    padding-bottom: 20px;
    grid-column: 1 / span 4;
    max-width: 550px;
    overflow-y: scroll;
    max-height: calc(100% - 15vh);
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    ${mq('l')} {
      display: block;
    }

    ${mq('xl')} {
      padding-right: 60px;
    }
  }
`;

export default StyledStackView;
